import { queryOptions, useQuery } from '@tanstack/react-query';

import { organizationSettingsApi } from '../api/organization-settings-api';

import { organizationSettingsKeys } from './organization-settings-keys';

export function organizationSettingsQueryOptions() {
  return queryOptions({
    queryKey: organizationSettingsKeys.all,
    queryFn: organizationSettingsApi.get,
  });
}

export function useOrganizationSettings() {
  return useQuery(organizationSettingsQueryOptions());
}
